const sectionStandardMap = {
  'ecr_client_acceptance': 'ECR - Client Acceptance',
  'independence': 'Independence',
  'engagement_acceptance': 'Engagement Acceptance',
  'higher_risk_engagements': 'Higher Risk Engagements',
  'contracting': 'Contracting',
  'deliverables_and_disclaimers': 'Deliverables and Disclaimers',
  'documentation': 'Documentation',
  'performance_and_review': 'Performance and Review',
  'final': 'Overall',  
}

export { sectionStandardMap }        